import { Box, Breadcrumbs, Tooltip, Typography } from '@mui/material'
import { NavigateNext } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import React from 'react'

/**
 * Breadcrumbs
 *
 * @param {Object} props
 * @param {Array} props.items - Breadcrumb items(Links and Text)
 * @param {Object || String} props.items.item - Breadcrumb
 * @param {String} props.items.item.link - URL
 * @param {String} props.items.item.label - URL
 */

const BreadcrumbList = ( { items = [] } ) => {
    return (
        <Breadcrumbs sx={{ color: "textSecondary", marginBottom: "10px", fontSize: "12px", '& .MuiBreadcrumbs-separator': { margin: "0" } }} separator={<NavigateNext fontSize="small" />} >
            {items.map( ( breadcrumb, index ) => {
                if ( breadcrumb === undefined || breadcrumb.length === 0 ) return ""
                if ( typeof breadcrumb !== 'string' && breadcrumb.link ) {
                    return <Box key={index} sx={{ '&:hover': { color: "secondary.main" } }}>
                        <Link className='breadcrumb-link' to={breadcrumb.link}>
                            <Tooltip title={breadcrumb.label}>
                                <Typography fontSize="inherit" noWrap className='truncate-at-1' sx={{ maxWidth: 150, '&:hover': { color: "secondary.main" } }} color="textSecondary" variant="subtitle2" textTransform="capitalize">{breadcrumb.label}</Typography>
                            </Tooltip>
                        </Link>
                    </Box>
                } else {
                    return <Tooltip key={index} title={breadcrumb}><Typography noWrap className='truncate-at-1' fontSize="inherit" sx={{ maxWidth: 150 }} color="textSecondary" variant="subtitle2" textTransform="capitalize">{breadcrumb}</Typography></Tooltip>
                }
            } )}
        </Breadcrumbs>
    )
}

export default BreadcrumbList
